import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {icons} from '../../../../ui/icons';
import {FormBuilder, FormControl, FormGroupDirective} from '@angular/forms';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {CommmCode} from 'src/app/utils/constante/CommonCode';
import {CriteriaSearch} from 'src/app/domain/CriteriaSearch';

@Component({
    selector: 'app-fournisseur-filtre',
    templateUrl: './fournisseur-filtre.component.html',
    styleUrls: ['./fournisseur-filtre.component.css']
})
export class FournisseurFiltreComponent implements OnInit {
    @Output() searchoptions = new EventEmitter<Partial<any>>();
    @ViewChild(FormGroupDirective) formDirective: FormGroupDirective;
    panelOpenState = false;

    commmCode = CommmCode;
    icons = icons;
    code: any = 'EP101';

    labelcommande = 'Type commande';
    public options = {};
    form = this.formBuilder.group({
        volume: this.formBuilder.control(null),
        type_commande: this.formBuilder.control(null),
        classification: this.formBuilder.control(null),
        territoire: this.formBuilder.control(null),
        zone: this.formBuilder.control(null),
        delegation: this.formBuilder.control(null),


    });

    constructor(private formBuilder: FormBuilder,
                private translate: AppTranslateService,
    ) {
    }

    ngOnInit(): void {
    }

    submit() {


        const searchvalue = [];

        if (this.form.value.volume != null) {
            searchvalue.push(
                new CriteriaSearch(
                    'pme',
                    this.form.value.volume || undefined,
                    '='
                ));
        }
        if (this.form.value.type_commande != null) {
            searchvalue.push(
                new CriteriaSearch(
                    'activite',
                    this.form.value.type_commande || undefined,
                    '='
                ));
        }
        if (this.form.value.classification != null) {
            searchvalue.push(
                new CriteriaSearch(
                    'categ',
                    this.form.value.classification || undefined,
                    '='
                ));
        }
        if (this.form.value.territoire != null) {
            searchvalue.push(
                new CriteriaSearch(
                    'territoireTn',
                    this.form.value.territoire || undefined,
                    '='
                ));
        }

        if (this.form.value.zone != null) {
            searchvalue.push(
                new CriteriaSearch(
                    'cdGouvernorat',
                    this.form.value.zone || undefined,
                    '='
                ));
        }

        if (this.form.value.delegation != null) {
            searchvalue.push(
                new CriteriaSearch(
                    'cdVille',
                    this.form.value.delegation || undefined,
                    '='
                ));
        }

        this.options = searchvalue;
        this.searchoptions.emit(this.options);
        this.options = {};
    }

    reset() {
        this.form.reset();
        this.formDirective.resetForm();
        this.searchoptions.emit(null);

    }

    getdiablecond(): boolean {
        if (this.form.value.zone != null) {
            return false;
        } else {
            return true;
        }

    }

    getFormControl(key: any) {
        return this.form.get(key) as FormControl;
    }

    send(value) {


        if (value == '01') {
            this.code = 'EP123';
        }
        if (value == '02') {
            this.code = 'EP101';
        }
        if (value == '03') {
            this.code = 'EP103';
        }
        if (value == '04') {
            this.code = 'EP104';
        }
        if (value == '05') {
            this.code = 'EP116';
        }
        if (value == '06') {
            this.code = 'EP102';
        }
        if (value == '07') {
            this.code = 'EP111';
        }
        if (value == '08') {
            this.code = 'EP119';
        }
        if (value == '09') {
            this.code = 'EP107';
        }
        if (value == '10') {
            this.code = 'EP124';
        }
        if (value == '11') {
            this.code = 'EP120';
        }
        if (value == '12') {
            this.code = 'EP115';
        }
        if (value == '13') {
            this.code = 'EP112';
        }
        if (value == '14') {
            this.code = 'EP108';
        }
        if (value == '15') {
            this.code = 'EP109';
        }
        if (value == '16') {
            this.code = 'EP118';
        }
        if (value == '17') {
            this.code = 'EP117';
        }
        if (value == '18') {
            this.code = 'EP106';
        }
        if (value == '19') {
            this.code = 'EP122'
        }
        if (value == '20') {
            this.code = 'EP105'
        }
        if (value == '21') {
            this.code = 'EP114'
        }
        if (value == '22') {
            this.code = 'EP121'
        }
        if (value == '23') {
            this.code = 'EP110'
        }
        if (value == '24') {
            this.code = 'EP113'
        }
        if (value == '99') {
            this.code = 'EP125'
        }

        //this.form.get("cateId").setValue(value.cateId);
        // this.form.get("souscategorie").setValue('CR03');
    }
}
